<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
                Overview
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">Stewardship is the process of acknowledging, thanking, and keeping a donor engaged with your organization after they have made a gift. This is a critically important process in the development cycle because maintaining relationships with current donors ensures your donor pipeline is sustainable.</p>
            
            <p class="text-[14px] leading-[22px] mb-[0.5rem] font-semibold">Rule of thumb:</p>
            <ul class="list-disc pl-5 mb-[0.5rem] text-[14px] leading-[22px]">
                <li>Develop “benefits” that tie the donor to the work of your organization.</li>
                <li>The more a donor gives, the more exclusive the “benefits” and “recognition” can be.</li>
                <li>If a donor is making a pledge over a period of years, provide benefits and recognition based on the amount of the donor's annual pledge payment.</li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';
// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 